import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { ROLE_QUERY_KEY, rolesService } from "../../../Services/rolesService";
import { Role } from "../../../Types/Role/RoleModel";
import DataTable from "react-data-table-component";
import { Col, Card, CardBody } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import { RoleTableColumn } from "../../../Data/DataTables/Role";

const RoleTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: users = [], isLoading } = useQuery({
    queryKey: ROLE_QUERY_KEY,
    queryFn: rolesService.getAllRole,
  });
  const filteredItems: Role[] = users.filter((item: Role) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  return (
    <Col sm="12">
      <Card>
        <CardBody>
          <FilterComponent
            onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFilterText(e.target.value)
            }
            filterText={filterText}
          />
          <div className="table-responsive">
            <DataTable
              className="custom-scrollbar"
              data={filteredItems}
              columns={RoleTableColumn}
              striped={true}
              pagination
              highlightOnHover
              progressPending={isLoading}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default RoleTable;
